module.exports = __webpack_public_path__ + "img/default-class.0e74d8de.png";